<app-navbar title="Rozkłady">
	<a class="btn btn-primary me-4" routerLink="/tourism-map/{{ id }}"> <i class="fas fa-map-marked-alt"></i> Mapa </a>
	<a class="btn btn-primary me-4" routerLink="/tourism-timetable/{{ id }}"> <i class="far fa-clock"></i> Godziny </a>
	<a class="btn btn-warning me-4" routerLink="/timetable/{{ id }}"> <i class="fas fa-radiation"></i> Podstawowe </a>
</app-navbar>
<ol class="breadcrumb">
	<li class="breadcrumb-item fw-bolder">{{ timetable?.sideName }}</li>
	<li class="breadcrumb-item" *ngFor="let item of timetable?.seasons">
		{{ item.destinationName }}
		<span *ngIf="timetable.side === 'departure'">({{ item.departureDate }} {{ item.accommodationFrom }})</span>
		<span *ngIf="timetable.side === 'return'"
			>({{ item.departureFromDestination }} {{ item.arrivalToLastStop }})</span
		>
	</li>
</ol>

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<ul class="nav nav-tabs" id="myTab" role="tablist">
	<li class="nav-item" role="presentation">
		<a
			class="nav-link active"
			id="destination-tab"
			data-bs-toggle="tab"
			href="#destination"
			role="tab"
			(click)="changeTab('destination')"
		>
			Docelowa
		</a>
	</li>
	<li class="nav-item" role="presentation">
		<a
			class="nav-link"
			id="passport-tab"
			data-bs-toggle="tab"
			href="#passport"
			role="tab"
			(click)="changeTab('passport')"
		>
			Paszportowa
		</a>
	</li>
	<li class="nav-item" role="presentation">
		<a
			class="nav-link"
			id="charges-tab"
			data-bs-toggle="tab"
			href="#charges"
			role="tab"
			(click)="changeTab('charges')"
		>
			Opłaty
		</a>
	</li>
	<li class="nav-item" role="presentation">
		<a class="nav-link" id="tgs-tab" data-bs-toggle="tab" href="#tgs" role="tab" (click)="changeTab('tgs')">
			TGS
		</a>
	</li>
	<li class="nav-item" role="presentation">
		<a class="nav-link" id="sms-tab" data-bs-toggle="tab" href="#sms" role="tab" (click)="changeTab('sms')">
			SMS
		</a>
	</li>
</ul>

<div class="tab-content my-4" id="myTabContent">
	<div class="tab-pane fade active show" id="destination" role="tabpanel">
		<h3>Lista Docelowa</h3>
		<app-tourism-transport-filters
			userFilters="tourism-transport-list"
			[originCityId]="originCityId"
			[offerName]="offerName"
			(selected)="filtersSelected($event)"
		>
		</app-tourism-transport-filters>
		<app-dynamic-table
			[elements]="data"
			[tableRows]="tableRows.destination"
			[haveLink]="false"
			(filtersClicked)="filtersOpen()"
		></app-dynamic-table>
	</div>
	<div class="tab-pane fade" id="passport" role="tabpanel">
		<h3>Lista Paszportowa</h3>
		<app-dynamic-table
			[elements]="data"
			[tableRows]="tableRows.passport"
			[haveLink]="false"
			(filtersClicked)="filtersOpen()"
		></app-dynamic-table>
	</div>
	<div class="tab-pane fade" id="charges" role="tabpanel">
		<h3>Opłaty</h3>
		<app-dynamic-table
			[elements]="data"
			[tableRows]="tableRows.charges"
			[haveLink]="false"
			(filtersClicked)="filtersOpen()"
		></app-dynamic-table>
	</div>
	<div class="tab-pane fade" id="tgs" role="tabpanel">
		<h3>TGS</h3>
		<app-dynamic-table
			[elements]="data"
			[tableRows]="tableRows.tgs"
			[haveLink]="false"
			(filtersClicked)="filtersOpen()"
		></app-dynamic-table>
	</div>
	<div class="tab-pane fade" id="sms" role="tabpanel">
		<h3>SMS</h3>
		<app-dynamic-table
			[elements]="dataSms"
			[tableRows]="tableRows.sms"
			[haveLink]="false"
			(filtersClicked)="filtersOpen()"
		></app-dynamic-table>
	</div>
</div>
